<div class="bq9-celebration"
     data-testid="bq9-container-celebration">
  <schedule-detail-header class="bq9-celebration-header"
                          title="Celebration"
                          [subtitle]="subtitle"
                          [backCallback]="goBack.bind(this)"
                          [backLabel]="getBackLabel()"
                          [showCloud]="true"
                          [isRefreshingInBackground]="isRefreshingInBackground()"></schedule-detail-header>

  <div class="celebration-content"
       [appDataUpdatedFade]="dataUpdatedPulse()"
       data-testid="bq9-container-celebration-content">
    @if (!dataLoaded) {
      <div class="skeleton-wrapper">
        <p-skeleton width="4rem"
                    height="1rem"></p-skeleton>
        <p-skeleton height="3.5rem"></p-skeleton>
        <p-skeleton height="3.5rem"></p-skeleton>
      </div>
    } @else {
      @if (areasWithIssues().length > 0) {
        <app-area-issues-list [areasWithIssues]="areasWithIssues()"
                              [getViewIssuesUrl]="getViewIssuesUrl.bind(this)"
                              [issuesSavingMap]="issuesSavingMap()"
                              (onViewIssue)="viewIssue($event)"></app-area-issues-list>
      } @else {
        <div class="no-issues-message">
          <i class="pi pi-verified"></i>
          <div>
            <p>No Items to Review</p>
            <p>No outstanding punch items were found from your BQ8 report.</p>
          </div>
        </div>
      }
      <button class="add-new-item-link"
              (click)="addNewItem()"
              data-testid="bq9-celebration-btn-add-item">
        Add New Item
      </button>
    }
  </div>
  <div class="celebration-footer"
       data-testid="bq9-celebration-footer">
    <p-button label="Review Summary &amp; Sign"
              styleClass="bqa-primary-btn p-fullwidth-button"
              (click)="reviewAndSign()"
              [disabled]="!canReviewAndSign()"
              data-testid="bq9-celebration-btn-review-sign" />
  </div>
</div>

<router-outlet />